import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import axios, { HttpStatusCode } from 'axios'
import qs from 'qs'

import { datadogClient } from '~/@app/init/datadog'

import { TOAST_STRING } from '../constants/strings'
import { errorHandlerService, toastService } from '../services'
import { envUtils } from './envUtils'
import { wrapErrorHandlerWithJwt, wrapRequestInterceptorWithJwt } from './jwtInterceptors'

const BASE_URL = (() => {
  if (envUtils.isLive) {
    return `https://messaging-api.${domainProvider.TARGET_DOMAIN}`
  }
  if (envUtils.isStaging) {
    return `https://messaging-api-staging.${domainProvider.TARGET_DOMAIN}`
  }

  return `https://messaging-api-dev.${domainProvider.TARGET_DOMAIN}`
})()

const noxios = axios.create({
  baseURL: BASE_URL,
  paramsSerializer: (params) => {
    return qs.stringify(params)
  },
})

noxios.interceptors.request.use(wrapRequestInterceptorWithJwt((config) => config))

noxios.interceptors.response.use(
  (response) => response,
  wrapErrorHandlerWithJwt(
    async (error: unknown) => {
      datadogClient.sendError(error as Error)
      if (navigator.onLine === false) {
        toastService.error(TOAST_STRING.networkOffline)
        return Promise.reject(error)
      }
      const axiosError = error as { response?: { status?: number } }
      const status = axiosError?.response?.status
      if (!status) {
        errorHandlerService.handle(error as Error)
        return Promise.reject(error)
      }
      if (status >= HttpStatusCode.InternalServerError) {
        toastService.error(TOAST_STRING.error)
      }
      errorHandlerService.handle(error as Error, {
        logType: 'error',
        useRemoteLogging: false,
      })
      return Promise.reject(error)
    },
    async (originalRequest, newAccessToken) => {
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
      return noxios(originalRequest)
    },
  ),
)

export default noxios
